/* Wishlist Hero page (app proxy /a/wishlist-hero/...) — bridge the app's
   "add to cart" / "add all to cart" to the theme's cart drawer.
   Wishlist Hero fires `wishlist-hero-cart-updated` after it adds to the cart;
   we then refresh the theme cart and open the drawer, like a normal add-to-cart. */
(function () {
  function openThemeCartDrawer() {
    // refresh <cart-items>/<cart-count> from the server cart
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
    // open the drawer
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
    } else {
      // fallback: trigger the header cart toggle
      var toggle = document.querySelector('[data-cart-toggle]');
      if (toggle) toggle.click();
    }
  }

  // Wishlist Hero dispatches these after adding to cart — listen broadly.
  ['wishlist-hero-cart-updated', 'wishlist-hero-add-to-cart-notification'].forEach(function (ev) {
    document.addEventListener(ev, openThemeCartDrawer);
    window.addEventListener(ev, openThemeCartDrawer);
  });

  // Reformat prices: "DKK 510.00" → "510 kr" (Danish). WH renders async, so re-run on changes.
  function formatPrices() {
    document.querySelectorAll('.wishlist-hero-list-card-product-price').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (!t || / kr$/.test(t)) return;          // already formatted
      var m = t.match(/(\d[\d.,]*)/);
      if (!m) return;
      var n = parseFloat(m[1].replace(/,/g, '')); // strip thousands sep, keep . decimal
      if (isNaN(n)) return;
      var out = (n % 1 === 0) ? String(Math.round(n)) : n.toFixed(2).replace('.', ',');
      el.textContent = out + ' kr';
    });
  }
  function init() {
    formatPrices();
    var root = document.querySelector('#wishlist-hero-shared-list-view') || document.body;
    if (root && window.MutationObserver) {
      new MutationObserver(function () { formatPrices(); }).observe(root, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
